// extracted by mini-css-extract-plugin
module.exports = {"header":"fSnstV","title":"VCsJxF","cancel":"JMJh8x"};